module.exports = __webpack_public_path__ + "static/media/momotransparent.a02163e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/momotransparent.png
// module id = 29
// module chunks = 0